import React from "react";
import styles from "./PayoutDetailsTable.module.css";

const PayoutDetailsTable = ({ payouts }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    const statusText = getStatusText(status);
    const className = statusText.toLowerCase();
    return (
      <span className={`${styles.statusBadge} ${styles[className]}`}>
        {statusText}
      </span>
    );
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "Paid";
      default:
        return "Unknown";
    }
  };

  return (
    <>
      {payouts && payouts.length > 0 ? (
        <table className={styles.payoutDetailsTable}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Paid by</th>
              <th>Account Number</th>
              <th>Reference Number</th>
              <th>Method of payment</th>
              <th>Paid on Date</th>
              <th>Amount Paid</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {payouts.map((payout) => (
              <tr key={payout.id}>
                <td>{payout.expert_name}</td>
                <td>Myburgo admin</td>
                <td>{payout.account_number}</td>
                <td>{payout.reference_number}</td>
                <td>{payout.fund_transfer_type}</td>
                <td>{formatDate(payout.payout_date)}</td>
                <td>₹ {payout.amount?.toLocaleString()}</td>
                <td>{getStatusBadge(payout.payout_status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No payout information available</p>
      )}
    </>
  );
};

export default PayoutDetailsTable;
